var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inputPhoto"},[_c('div',{staticClass:"inputArea",class:{
      disable: _vm.distance > _vm.photoMissionDistance || _vm.isCleared,
    },on:{"click":_vm.onNoLogin}},[_c('label',{attrs:{"for":"file_upload"}},[_c('img',{attrs:{"src":require("@/assets/camera.svg")}}),_vm._v("\n      "+_vm._s(_vm.isCleared ? "達成済" : "写真をアップロード")+"\n\n      "),(
          !(
            _vm.distance > _vm.photoMissionDistance ||
            _vm.isLoggedInWithFirebaseAuth === false ||
            _vm.isCleared
          )
        )?_c('input',{attrs:{"id":"file_upload","type":"file","accept":"image/*"},on:{"change":_vm.onCaptureImage}}):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-daf65698","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Missions/InputPhoto.vue
// module id = null
// module chunks = 